import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/share/vk.svg'
import _imports_1 from '@/assets/share/fb.svg'
import _imports_2 from '@/assets/share/tg.svg'
import _imports_3 from '@/assets/share/cl.svg'


const _withScopeId = n => (_pushScopeId("data-v-0a65da64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-share" }
const _hoisted_2 = { class: "tp-share__buttons" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "vk-share"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "fb-share"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "tg-share"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "copy-share"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "tp-share__button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.open('VK')))
      }, _hoisted_4),
      (2<1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "tp-share__button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.open('FB')))
          }, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "tp-share__button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.open('TG')))
      }, _hoisted_8),
      _createElementVNode("div", {
        class: "tp-share__button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.open('COPY')))
      }, _hoisted_10)
    ])
  ]))
}